import { Typography, Stack, Divider } from "@mui/material";
import { Box } from "@mui/system";
import { icons } from "assets/AssetHelper";
import { useThemePalette } from "common/hooks/theme_palette";
import { useTranslation } from "react-i18next";
import React from "react";
import * as dayjs from "dayjs";

export default function OrderDetailsHead({
  orderPlaceIn,
  deliveryIn,
  wrapper,
  deliveryTime,
}) {
  const { t } = useTranslation();
  const { grayTwo } = useThemePalette();
  return (
    <Stack bgcolor={"#fff"} p={"24px"} gap={"20px"}>
      <Stack justifyContent="space-between" direction={{ xs: "column", md: "row" }} gap={2}>
        <Stack width={{ xs: "100%", md: "50%" }} direction="row" gap="10px" alignItems="center">
          <Box sx={{ minWidth: "24px" }}>
            <img alt="date icon" src={icons?.dateIcon} width="24px" height="24px" />
          </Box>
          <Stack direction={{ xs: "column", sm: "row" }} gap={{ xs: 0.5, sm: 1 }} alignItems={{ xs: "flex-start", sm: "center" }}>
            <Typography color={grayTwo} sx={{ fontSize: { xs: "14px", sm: "16px" } }}>{t("orders.order_place_in")}:</Typography>
            <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: "500" }}>
              {dayjs(orderPlaceIn).format("DD-MM-YYYY, hh:mm a")}
            </Typography>
          </Stack>
        </Stack>
        <Stack width={{ xs: "100%", md: "50%" }} direction="row" gap="10px" alignItems="center">
          <Box sx={{ minWidth: "24px" }}>
            <img alt="time icon" src={icons?.timeIcon} width="24px" height="24px" />
          </Box>
          <Stack direction={{ xs: "column", sm: "row" }} gap={{ xs: 0.5, sm: 1 }} alignItems={{ xs: "flex-start", sm: "center" }}>
            <Typography color={grayTwo} sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
              {t("orders.desired_delivery_in")}:
            </Typography>
            {deliveryTime || deliveryIn ? (
              <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: "500" }}>
                {dayjs(deliveryIn).format("DD-MM-YYYY")} , {deliveryTime}
              </Typography>
            ) : (
              <Typography sx={{ fontSize: { xs: "14px", sm: "16px" }, color: "text.secondary" }}>{t("orders.not_specified")}</Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
      {wrapper && (
        <>
          <Divider />
          <Stack gap={2}>
            <Typography variant="h6" fontWeight="bold">
              {t("orders.wrapper_to_all_items")}
            </Typography>
            <Stack direction="row" gap={4} flexWrap="wrap">
              {/* Main Wrapper Image and Info */}
              <Stack direction="row" gap={2}>
                {wrapper.wrapper_image && (
                  <Box
                    component="img"
                    src={wrapper.wrapper_image}
                    alt={wrapper.title}
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: 2,
                      objectFit: "cover",
                    }}
                  />
                )}
                <Stack gap={0.5}>
                  <Typography fontWeight="bold">
                    <Typography
                      component="span"
                      fontSize={14}
                      color="text.secondary"
                    >
                      {t("orders.wrap")}
                    </Typography>{" "}
                    ({wrapper.title})
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t("orders.type")}: {wrapper.wrappable_type}
                  </Typography>
                  <Typography variant="body2" fontWeight="bold" color="primary">
                    {wrapper.cost} {wrapper.currency?.name}
                  </Typography>
                </Stack>
              </Stack>

              {/* Ribbon */}
              {wrapper.ribbon && (
                <Stack gap={0.5}>
                  <Typography variant="subtitle2" color="text.secondary">
                    {t("orders.ribbon")}
                  </Typography>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: 1,
                        bgcolor: wrapper.ribbon.presentation,
                        border: "1px solid #e0e0e0",
                      }}
                    />
                    <Typography variant="body2">
                      {wrapper.ribbon.name}
                    </Typography>
                  </Stack>
                </Stack>
              )}

              {/* Wrapper Variant (Color/Shape) */}
              {wrapper.wrap_variant && (
                <Stack gap={0.5}>
                  <Typography variant="subtitle2" color="text.secondary">
                    {t("orders.variant")}
                  </Typography>
                  <Stack direction="row" alignItems="center" gap={1}>
                    {wrapper.wrap_variant.color && (
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: 1,
                          bgcolor: wrapper.wrap_variant.color.presentation,
                          border: "1px solid #e0e0e0",
                        }}
                      />
                    )}
                    <Typography variant="body2">
                      {wrapper.wrap_variant.name}
                    </Typography>
                  </Stack>
                </Stack>
              )}
            </Stack>
          </Stack>
        </>
      )}
    </Stack>
  );
}
